module.exports = __webpack_public_path__ + "img/LP_Full_Main.582a964f.svg";